
















































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { IIDNameAndDescription, IPersonBase } from '@/api/types/response.types'
import { EEntities } from '@/types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  name: 'EntityInfoFlyout',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    entityId: {
      type: Number,
      required: true,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    workflow: {
      type: Object as () => IIDNameAndDescription,
      required: true,
    },
    members: {
      type: Array as () => IPersonBase[],
      required: true,
    },
  },

  data() {
    return {
      RouteAssistant,
      ColorAssistant,
      isLoading: true,
      isSubmittingNote: false,
      showEditor: false,
      note: '',
      closeOut: false,
    }
  },
  computed: {
    visible: {
      get(): Boolean {
        return this.show
      },
      set(newValue: boolean) {
        this.$emit('update:show', newValue)
      },
    },
    drawerWidthPct(): string {
      return '100%'
    },
    isMailbox(): boolean {
      return this.entityType === EEntities.MAILBOXES
    },
    hasNote(): boolean {
      return this.note !== null
    },
    hasWorkflowDescription(): boolean {
      return (
        this.workflow.description !== null &&
        this.workflow.description.trim() !== ''
      )
    },
    entitySingularName(): string {
      return TextAssistant.entitySingularName(this.entityType).toLowerCase()
    },
  },
  watch: {
    visible: {
      async handler(val: boolean) {
        if (val) {
          this.closeOut = false
          this.isLoading = true
          await this.getNote()
          this.isLoading = false
        } else {
          this.showEditor = false
        }
      },
    },
    closeOut: {
      async handler(val: boolean) {
        if (val) {
          this.visible = false
        }
      },
    },
  },

  methods: {
    slideOutInfo() {
      this.visible = !this.visible
      this.closeOut = true
    },
    async getNote() {
      try {
        let response
        if (this.isMailbox) {
          response = await MailboxesAPI.get_Note(this.entityId)
        } else {
          response = await InternalProjectsAPI.get_Note(this.entityId)
        }
        this.note = response.description
      } catch (error) {
        this.$error.emit(error)
      }
    },
    goToWorkflowDetail() {
      if (this.$permissions.isAdminOrOwner) {
        RouteAssistant.goToWorkflowDetail(
          this.$router,
          this.$route.params.accountId,
          this.workflow.id,
        )
      }
    },
    async updateNote() {
      try {
        if (this.isMailbox) {
          await MailboxesAPI.put_Note(this.entityId, this.note)
        } else {
          await InternalProjectsAPI.put_Note(this.entityId, this.note)
        }
        this.showEditor = false
        setTimeout(() => (this.closeOut = true), 300)
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
    handleCancel() {
      this.$emit('update:show', false)
    },
  },
})
